const sizeMap = {
  '4': 'small',
  '6': 'medium',
  '8': 'medium',
  '10': 'medium',
  '12': 'medium',
  'XS': 'large',
  'S': 'large',
  'M': 'large',
  'L': 'large'
};

function getElementsForForm(form) {
  if (!form) return null;

  return {
    bikiniSelect: form.querySelector('select[name^="properties[Bikiniset"]'),
    tailSelect: form.querySelector('select[name^="properties[Losse Zeemeermin staart"]'),
    monovinSelect: form.querySelector('select[name^="properties[Losse monovin"]'),
    hiddenBikini: form.querySelector('input[type="hidden"][name^="properties[Bikiniset"]'),
    hiddenTail: form.querySelector('input[type="hidden"][name^="properties[Losse Zeemeermin staart"]'),
    hiddenMonovin: form.querySelector('input[type="hidden"][name^="properties[Losse monovin"]'),
    hiddenBundleSelection: form.querySelector('input[type="hidden"][name="properties[_bundle_selection]"]')
  };
}

function getTailSize(value) {
  if (!value) return null;
  const match = value.match(/\b(XS|S|M|L|10|12|8|6|4)\b/i);
  return match ? match[1].toUpperCase() : null;
}

function findMonovinOption(monovinSelect, sizeLabel) {
  if (!monovinSelect) return null;

  return Array.from(monovinSelect.options).find(option => {
    return option.textContent.toLowerCase().includes(sizeLabel.toLowerCase());
  });
}

function triggerSelectEvents(select) {
  if (!select) return;
  select.dispatchEvent(new Event('input', { bubbles: true }));
  select.dispatchEvent(new Event('change', { bubbles: true }));
}

function lockMonovinSelect(monovinSelect) {
  if (!monovinSelect) return;

  monovinSelect.setAttribute('aria-disabled', 'true');
  monovinSelect.tabIndex = -1;
  monovinSelect.classList.add('auto-linked-monovin-select');
}

function addHelperText(monovinSelect) {
  if (!monovinSelect) return;

  let existingNote = monovinSelect.nextElementSibling;
  while (existingNote) {
    if (existingNote.classList && existingNote.classList.contains('auto-linked-monovin-note')) {
      return;
    }
    existingNote = existingNote.nextElementSibling;
  }

  const note = document.createElement('div');
  note.className = 'auto-linked-monovin-note';
  note.textContent = 'Monovin maat wordt automatisch gekoppeld aan de gekozen staartmaat.';
  note.style.fontSize = '14px';
  note.style.marginTop = '6px';
  note.style.color = '#666';

  const oosNotice = monovinSelect.parentElement?.querySelector('#oos-links-monovin');

  if (oosNotice) {
    oosNotice.insertAdjacentElement('afterend', note);
  } else {
    monovinSelect.insertAdjacentElement('afterend', note);
  }
}

function prepareMonovinUi(form) {
  const els = getElementsForForm(form);
  if (!els || !els.monovinSelect) return false;

  lockMonovinSelect(els.monovinSelect);
  addHelperText(els.monovinSelect);

  return true;
}

function updateHiddenFields(form) {
  const els = getElementsForForm(form);
  if (!els) return;

  const {
    bikiniSelect,
    tailSelect,
    monovinSelect,
    hiddenBikini,
    hiddenTail,
    hiddenMonovin,
    hiddenBundleSelection
  } = els;

  if (hiddenBikini && bikiniSelect) hiddenBikini.value = bikiniSelect.value || '';
  if (hiddenTail && tailSelect) hiddenTail.value = tailSelect.value || '';
  if (hiddenMonovin && monovinSelect) hiddenMonovin.value = monovinSelect.value || '';

  if (hiddenBundleSelection) {
    const bikiniValue = bikiniSelect ? bikiniSelect.value || '' : '';
    const tailValue = tailSelect ? tailSelect.value || '' : '';
    const monovinValue = monovinSelect ? monovinSelect.value || '' : '';
    hiddenBundleSelection.value = `${bikiniValue} <> ${tailValue} <> ${monovinValue}`;
  }
}

function syncMonovin(form, reason = '') {
  const els = getElementsForForm(form);
  if (!els) {
    return false;
  }

  const { tailSelect, monovinSelect } = els;

  if (!tailSelect || !monovinSelect) {
    return false;
  }

  lockMonovinSelect(monovinSelect);
  addHelperText(monovinSelect);

  const tailSize = getTailSize(tailSelect.value);

  if (!tailSize) {
    updateHiddenFields(form);
    return false;
  }

  const wantedSize = sizeMap[tailSize];

  if (!wantedSize) {
    updateHiddenFields(form);
    return false;
  }

  const matchingOption = findMonovinOption(monovinSelect, wantedSize);

  if (!matchingOption) {
    updateHiddenFields(form);
    return false;
  }

  if (monovinSelect.value !== matchingOption.value) {
    monovinSelect.value = matchingOption.value;
    triggerSelectEvents(monovinSelect);
  }

  updateHiddenFields(form);

  return true;
}

function bindBundleForm(bundleWrapper) {
  const form = bundleWrapper.closest('form');
  if (!form) return false;

  if (form.dataset.monovinSyncBound !== 'true') {
    form.addEventListener('change', function (event) {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement)) return;

      const targetForm = target.closest('form');
      if (targetForm !== form) return;

      if (target.name && target.name.startsWith('properties[Losse Zeemeermin staart')) {
        syncMonovin(form, 'change event');
      }

      if (
        (target.name && target.name.startsWith('properties[Bikiniset')) ||
        (target.name && target.name.startsWith('properties[Losse monovin'))
      ) {
        updateHiddenFields(form);
      }
    }, true);

    form.addEventListener('input', function (event) {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement)) return;

      const targetForm = target.closest('form');
      if (targetForm !== form) return;

      if (target.name && target.name.startsWith('properties[Losse Zeemeermin staart')) {
        syncMonovin(form, 'input event');
      }

      if (
        (target.name && target.name.startsWith('properties[Bikiniset')) ||
        target.name === 'properties[Losse monovin]'
      ) {
        updateHiddenFields(form);
      }
    }, true);

    form.dataset.monovinSyncBound = 'true';
  }

  if (bundleWrapper.dataset.monovinUiObserverBound !== 'true') {
    const uiObserver = new MutationObserver(() => {
      prepareMonovinUi(form);

      const els = getElementsForForm(form);
      if (!els || !els.tailSelect) return;

      const currentTailSize = getTailSize(els.tailSelect.value);
      if (currentTailSize) {
        syncMonovin(form, 'mutation observer');
      }
    });

    uiObserver.observe(bundleWrapper, {
      childList: true,
      subtree: true
    });

    bundleWrapper.dataset.monovinUiObserverBound = 'true';
  }

  prepareMonovinUi(form);
  syncMonovin(form, 'initial');

  return true;
}

function bindAllBundleForms() {
  const bundleWrappers = document.querySelectorAll('[data-simple-bundles-options]');
  if (!bundleWrappers.length) {
    return false;
  }

  bundleWrappers.forEach(bundleWrapper => {
    bindBundleForm(bundleWrapper);
  });

  return true;
}

function startBundleMonovinSync() {
  bindAllBundleForms();

  const observer = new MutationObserver(() => {
    bindAllBundleForms();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    observer.disconnect();
  }, 10000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startBundleMonovinSync);
} else {
  startBundleMonovinSync();
}